import React from 'react';
import classNames from 'classnames';
import {
  ColorPalette,
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import {
  images,
} from '../../../../assets/image';

const IconWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const getTextColor = () => {
    const { textColor } = props.widgetParams;

    if (textColor === ColorPalette.primary) {

      return styles.primaryTitle;

    } else if (textColor === ColorPalette.onSurface) {

      return styles.onSurfaceTitle;

    } else {
      return styles.onSurfaceMidTitle;
    }
  }
  const {
    defaultPaddings,
  } = props;
  return (
    <div
      className={classNames([styles.widgetContainer])}
      style={defaultPaddings}
    >
      <img
        src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
        className={classNames([styles.widgetImage])}
      />
      <div
        className={classNames([styles.imageOverlay])}
      />
      <p
        className={classNames([styles.title, getTextColor()])}
      >
        {props.widgetParams.title}
      </p>
      {
        `${props.widgetParams.isButton}` === 'true' &&
        <button className={classNames([styles.footerButton])}>
          {props.widgetParams.buttonText}
        </button>
      }
    </div>
  );
};

export default IconWidget;
